module.exports = __webpack_public_path__ + "fonts/icomoon.71a0df15.woff";